import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import WithdrawalBg from '../../../../../../../assets/stake/withdrawal.svg';
import Header from '../../../../../../../components/Stake/header';
import OMUniIcon from '../../../../../../../assets/images/OM icon.png';
import * as zenWbtcUniStakeActions from '../../../../../../../actions/zen-wbtc-uni-stake-actions';
import { formatToken } from '../../../../../../../helpers/token-helper';
import Details from '../../../../../../../components/Stake/frame/details';

const WithdrawDetails = () => {
  const dispatch = useDispatch();
  const { unstakedBalance } = useSelector((state) => state.ZENWBTCUNIstake.stake);
  const withdrawBalance = `${formatToken(unstakedBalance, 10)} OM`;

  const descriptions = ['This will be withdrawn to the current connected wallet.'];

  return (
    <>
      <Header
        icon={OMUniIcon}
        title='OM-Withdrawal'
        onClickBack={() => dispatch(zenWbtcUniStakeActions.stakeReset())}
      />
      <Details
        title='You are Withdrawing:'
        token={withdrawBalance}
        buttonClick={() => dispatch(zenWbtcUniStakeActions.withdrawUnstakedSend())}
        descriptions={descriptions}
        textButton='Withdraw'
        stepBg={WithdrawalBg}
      />
    </>
  );
};

export default WithdrawDetails;
